import React from "react";
import PT from "prop-types";
import { SearchBox } from "@quintype/components";

import "./styles.m.css";

import { SearchIcon } from "../../basic/icons/search-icon";
import { CloseIcon } from "../../basic/icons/close-icon";
import { Button } from "../../basic/button/";
import VideoSectionLink from "../../atoms/video-section-link";

function DrawForm({ children }) {
  return [
    <label styleName="label" htmlFor="searchForm" key="1">
      {children}
    </label>,
    <Button type="submit" key="2" styleName="button">
      Search
    </Button>
  ];
}

class NavbarSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSearchFormOpen: false,
      initialized: false
    };
  }

  componentDidMount() {
    this.setState({
      initialized: true
    });
  }

  toggleSearchForm() {
    this.setState({ isSearchFormOpen: !this.state.isSearchFormOpen }, () => {
      document.getElementById("searchForm").focus();
    });
  }

  render() {
    const formStyle = {
      transform: this.state.isSearchFormOpen ? "rotateX(0deg)" : "rotateX(90deg)"
    };
    let initialStyle = {
      opacity: this.state.initialized ? 1 : 0
    };
    return (
      <div styleName="search" className={this.props.className} style={initialStyle}>
        <VideoSectionLink />
        <button styleName="search__btn" onClick={() => this.toggleSearchForm()}>
          <SearchIcon color={this.props.searchIconColor || "#fff"} />
        </button>
        <div styleName="search__form" style={formStyle}>
          <div styleName="search__form-container">
            <SearchBox
              styleName="search__box"
              template={DrawForm}
              inputId="searchForm"
              inputRef={input => (this.input = input)}
              inputClassName="input"
              formRef={searchForm => (this.searchForm = searchForm)}
              onSubmitHandler={() => this.setState({ isSearchFormOpen: false })}
              onEscape={() => this.setState({ isSearchFormOpen: false })}
              placeholder="Search for headline, topics, authors etc"
            />
            <div styleName="close-icon" onClick={() => this.toggleSearchForm()}>
              <CloseIcon />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NavbarSearch.propTypes = {
  searchIconColor: PT.string,
  className: PT.string
};

export { NavbarSearch };
